import React from 'react';
import { MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { companyInfo } from '../mockData';

const Hero = () => {
  const navigate = useNavigate();
  const scrollToContact = () => {
    navigate('/contact');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1600)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/80 to-black/70"></div>
      </div>

      {/* Decorative Elements - More Playful */}
      <div className="absolute top-20 right-10 w-96 h-96 bg-gold/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-gold/5 rounded-full blur-2xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo Badge - More Playful */}
          <div className="inline-flex items-center justify-center mb-8 animate-float">
            <div className="relative transform hover:scale-110 transition-transform duration-500">
              <div className="w-56 h-56 rounded-full flex items-center justify-center transform hover:rotate-6 transition-transform duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_sparks-connect/artifacts/di0n3tc5_OlMctoodles%20Logo%20-%20Main.JPG" 
                  alt="Ol' McToodles Electric Logo" 
                  className="w-full h-full object-contain drop-shadow-2xl"
                />
              </div>
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight"
            style={{
              backgroundImage: 'linear-gradient(90deg, #8B6914, #C9A961, #E8D5A3, #C9A961, #8B6914)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            {companyInfo.name}
          </h1>
          
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="h-1 w-16 bg-gold rounded-full"></div>
            <div className="h-2 w-2 bg-gold rounded-full animate-pulse"></div>
            <div className="h-1 w-24 bg-gold rounded-full"></div>
            <div className="h-2 w-2 bg-gold rounded-full animate-pulse"></div>
            <div className="h-1 w-16 bg-gold rounded-full"></div>
          </div>
          
          <p className="text-2xl md:text-3xl text-gold font-semibold mb-8 tracking-wide">
            {companyInfo.tagline}
          </p>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
            Licensed electrical contracting services for residential, commercial, and industrial clients in the Kootenays
          </p>

          {/* Location with playful design */}
          <div className="inline-flex items-center space-x-2 text-white/80 mb-12 bg-white/5 px-6 py-3 rounded-full backdrop-blur-sm border border-gold/20">
            <MapPin className="w-5 h-5 text-gold" />
            <span className="text-lg">{companyInfo.location}</span>
          </div>

          {/* CTA Buttons - More Playful */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-gold hover:bg-gold/90 text-black font-bold px-10 py-7 text-lg rounded-2xl shadow-2xl hover:shadow-gold/40 transition-all duration-300 hover:scale-110 hover:-rotate-2 transform"
            >
              ⚡ Get a Free Quote
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-gold text-gold hover:bg-gold hover:text-black font-bold px-10 py-7 text-lg rounded-2xl transition-all duration-300 hover:scale-110 hover:rotate-2 transform"
              onClick={() => window.location.href = `tel:${companyInfo.phone}`}
            >
              📞 Call Now
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
